import { UserCellSkeleton } from "@modules/members/components/userCellSkeleton"
import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"

type SearchStaffInputSkeletonProps = {
  className?: string
  label?: string
  isRequiredInput?: boolean
} & React.ComponentProps<"div">

export function SearchStaffInputSkeleton({
  className,
  label,
  isRequiredInput,
  ...props
}: SearchStaffInputSkeletonProps) {
  const theme = useTheme()

  const defaultClassName = "flex flex-column gap-3 w-full"

  return (
    <div className={className ?? defaultClassName} {...props}>
      {label && (
        <HUText type="label" color={theme.inputLabelColor} fontStyle="LS">
          {label.toUpperCase()}
          {isRequiredInput && (
            <HUText fontStyle="LL" color={theme.necessaryInput}>
              {" "}
              *
            </HUText>
          )}
        </HUText>
      )}

      <div className="grid">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="col-6">
            <UserCellSkeleton
              subtitle={true}
              avatarSize={40}
              className="flex gap-2 justify-content-center cursor-pointer border-1 border-neutralColor-200 border-round-2xl px-2 py-3"
            />
          </div>
        ))}
      </div>
    </div>
  )
}
